<div class="card h-full">
  <div class="card-header">
    <h3 class="card-title">Subscription</h3>
  </div>
  <div class="card-body p-0">
    <kendo-grid
      [kendoGridBinding]="repState.repSubscriptions"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)"
      (remove)="removeHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <div class="flex items-center p-2">
          <button gdAdminOnly
            type="button"
            kendoGridAddCommand
            kendoButton
            look="flat"
            icon="plus"
            class="mr-2"
          >
            Add New Record
          </button>
          <button gdAdminOnly
            type="button"
            kendoButton
            look="flat"
            icon="refresh"
            class="ml-auto"
          >
            Refresh
          </button>
        </div>
      </ng-template>
      <kendo-grid-column
        field="subscriptionDescription"
        title="Subscription"
        width="200"
      >
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="w-full"
            [data]="activeSubscriptions"
            textField="subscriptionDescription"
            valueField="subscriptionTypeID"
            valuePrimitive="true"
            [popupSettings]="{ height: 200 }"
            [formControl]="formGroup.get('subscriptionID')"
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="cost"
        title="Cost"
        width="75"
        [format]="{ style: 'currency', currency: 'USD' }"
      >
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <kendo-numerictextbox
            [format]="'n2'"
            class="w-full"
            [formControl]="formGroup.get(column.field)"
          ></kendo-numerictextbox>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="userID" title="User ID" width="100">
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox w-full"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Action" width="175" gdAdminOnly>
        <ng-template
          kendoGridCellTemplate
          let-isNew="isNew"
          let-dataItem="dataItem"
          let-formGroup="formGroup"
        >
          <div class="flex gap-2">
            <button kendoGridEditCommand [primary]="true" kendoButton look="flat" size="small" gdAdminOnly>
              <ng-icon name="heroPencil"></ng-icon> Edit
            </button>
            <button kendoGridRemoveCommand *ngIf="dataItem.active" kendoButton look="flat" size="small" gdAdminOnly>
              <ng-icon name="heroTrash"></ng-icon>
            </button>
            <button kendoGridSaveCommand kendoButton look="flat" size="small" [disabled]="formGroup?.invalid" gdAdminOnly>
              <ng-icon name="heroCheckCircle"></ng-icon>
            </button>
            <button kendoGridCancelCommand kendoButton look="flat" size="small">
              <ng-icon name="heroXMark"></ng-icon>
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>
